var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_782_7371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.512578 11.9491C0.512016 13.9813 1.04302 15.9656 2.0527 17.7146L0.416016 23.6905L6.53152 22.087C8.22299 23.0078 10.1181 23.4902 12.044 23.4904H12.0491C18.4067 23.4904 23.582 18.317 23.5847 11.9582C23.586 8.87692 22.3871 5.97948 20.2089 3.79961C18.0311 1.61992 15.1347 0.418887 12.0486 0.41748C5.6902 0.41748 0.515297 5.59061 0.512672 11.9491",
    fill: "url(#paint0_linear_782_7371)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100313 11.9452C0.0996563 14.0506 0.649687 16.1059 1.69537 17.9175L0 24.1075L6.33478 22.4466C8.08022 23.3982 10.0454 23.9 12.0451 23.9007H12.0502C18.636 23.9007 23.9972 18.5412 24 11.9548C24.0011 8.76281 22.7591 5.76122 20.5031 3.50325C18.2468 1.24556 15.2468 0.0013125 12.0502 0C5.46337 0 0.102938 5.35875 0.100313 11.9452ZM3.87291 17.6055L3.63637 17.23C2.64206 15.649 2.11725 13.822 2.118 11.946C2.12006 6.47147 6.57544 2.0175 12.054 2.0175C14.7071 2.01863 17.2005 3.05288 19.0759 4.92938C20.9512 6.80606 21.9831 9.30075 21.9824 11.9541C21.98 17.4286 17.5245 21.8831 12.0502 21.8831H12.0463C10.2638 21.8822 8.51569 21.4035 6.99113 20.4989L6.62831 20.2838L2.86912 21.2693L3.87291 17.6055Z",
    fill: "url(#paint1_linear_782_7371)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06383 6.95156C8.84014 6.45441 8.60473 6.44438 8.39202 6.43566C8.21783 6.42816 8.0187 6.42872 7.81977 6.42872C7.62064 6.42872 7.29711 6.50363 7.02364 6.80222C6.74989 7.1011 5.97852 7.82335 5.97852 9.29231C5.97852 10.7613 7.04848 12.181 7.19764 12.3804C7.34698 12.5795 9.26323 15.6905 12.2981 16.8873C14.8204 17.8819 15.3336 17.6841 15.881 17.6342C16.4285 17.5845 17.6477 16.9121 17.8964 16.2149C18.1453 15.5178 18.1453 14.9202 18.0707 14.7953C17.996 14.6709 17.7969 14.5962 17.4983 14.447C17.1997 14.2977 15.7317 13.5753 15.458 13.4756C15.1843 13.3761 14.9853 13.3264 14.7861 13.6253C14.587 13.9238 14.0152 14.5962 13.841 14.7953C13.6669 14.9949 13.4926 15.0198 13.1941 14.8704C12.8953 14.7206 11.9337 14.4057 10.7929 13.3886C9.90523 12.5972 9.30598 11.6198 9.1318 11.3209C8.95761 11.0224 9.11314 10.8606 9.26286 10.7118C9.39702 10.578 9.56155 10.3631 9.71098 10.1888C9.85986 10.0145 9.90955 9.89006 10.0091 9.69094C10.1088 9.49163 10.0589 9.31725 9.98436 9.16791C9.90955 9.01856 9.32933 7.54191 9.06383 6.95156Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_782_7371",
    x1: 1158.85,
    y1: 2327.71,
    x2: 1158.85,
    y2: 0.41748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_782_7371",
    x1: 1200,
    y1: 2410.75,
    x2: 1200,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_782_7371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.1875,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/WhatsappIcon.51aba7090d401df3ca5e642d3134273e.svg";
export { ForwardRef as ReactComponent };